
// export const logout = ( state ) => {
// }

export const setRacks = (state, racks) => {
    state.racks = racks
}

export const setRacksSelectable = (state, racks) => {
    state.racksSelectable = racks
}

export const setRacksPaginated = (state, racksPaginatedData) => {
    state.racksPaginatedData = racksPaginatedData
}

export const setRackDetail = (state, rack) => {
    state.rack = rack
}

export const saveNewRacks = (state, rack) => {
    state.racks.unshift(rack)
    state.createdData = rack;
}

export const saveUpdatedRack = (state, rack) => {
    state.racks.unshift(rack)
    state.updatedData = rack;
}

export const setDeleteRack = (state, rack) => {
    state.racksPaginatedData.data.filter(x => x.id !== rack.id);
    state.deletedData = rack
}

export const setRackIsLoading = (state, isLoading) => {
    state.isLoading = isLoading
}

export const setRackIsCreating = (state, isCreating) => {
    state.isCreating = isCreating
}

export const setRackIsUpdating = (state, isUpdating) => {
    state.isUpdating = isUpdating
}

export const setRackIsDeleting = (state, isDeleting) => {
    state.isDeleting = isDeleting
}